<template>
	<header-block v-if="showHeader" title="MGChat Litmus Testing Tool"></header-block>
	<div>
		<div id="working-indicator" v-if="working">
			Working...
		</div>
		<v-row v-if="showTools">
			<v-col>
				<v-select class="custom-placeholder-color custom-label-color" v-model="selectedTest" :items="tests"
					item-title="test" return-object label="Select a Test" color="white" bg-color="#1c1c1cff"
					text-color="white" flat="true" variant="outlined"></v-select>
			</v-col>
			<v-col cols="3">
				<v-btn style="height: 56px;" color="green" @click="runTest()"><v-icon icon="mdi-play"></v-icon></v-btn> <v-btn style="height: 56px;" color="red" @click="reset()"><v-icon icon="mdi-delete"></v-icon></v-btn>
			</v-col>
		</v-row>
		<div class="responseArea" v-html="allText" ref="responseArea"></div>
		<v-btn
			style="position: fixed; bottom: 140px; right: 30px; z-index: 1100;"
			color="blue"
			icon="mdi-content-copy"
			@click="copyResponseArea"
			title="Copy to clipboard"
		>
			<v-icon icon="mdi-content-copy"></v-icon>
		</v-btn>
		<textarea v-model="inText" @keypress="onKeyPress" @keydown="onKeyDown" placeholder="Loading..." ref="consoleTextarea">
		</textarea>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
export default {
	name: "LitmusTestPage",
	mixins: [Services],
	components: {HeaderBlock},
	el: '#app',
	data() {
		return {
			prompt: "MGChat:$ ",
			allText: "",
			inText: "",
			messages: [],
			cursorIndex: 0,
			selectedTest: null,
			showHeader: false,
			showTools: false,
			tests: [
				{ 
					test: "What subscriptions do I have?", 
					evaluationPoints: "Information should be correct and laid out well. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "What subscriptions could I cancel?", 
					evaluationPoints: "Information should be correct, with valid suggestions and laid out well. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "How much have I spent in the last week?", 
					evaluationPoints: "Information should be correct with correct date range. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "What is my current account balance?", 
					evaluationPoints: "Information should be correct and detailed. Offer further suggestions or assistance." 
				},
				{ 
					test: "List my recent transactions.", 
					evaluationPoints: "Information should be correct with recent transactions. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "What are my upcoming bills?", 
					evaluationPoints: "Information should be correct with upcoming bills. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "How can I save more money?", 
					evaluationPoints: "Provide practical and personalized tips. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice" 
				},
				{ 
					test: "How can I improve my credit score?", 
					evaluationPoints: "Provide practical and personalized tips, mention paying off debts, mention responsible use of credit cards, mention no CCJs. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice" 
				},
				{ 
					test: "Can you help me create a budget?", 
					evaluationPoints: "Provide practical and personalized budgeting tips, point the user to the spending plan tool in the Money Guided app. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice" 
				},
				{ 
					test: "What investment options are available to me?", 
					evaluationPoints: "Provide information on various investment options. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "How can I reduce my debt?", 
					evaluationPoints: "Provide practical and personalized debt reduction tips. Concise response. Offer further suggestions or assistance. Make sure all response is guidance and not advice" 
				},
				{ 
					test: "What are the benefits of using MGChat?", 
					evaluationPoints: "Highlight key features and benefits of MGChat. Mention whatsapp, mention document uploading and recognition. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "How secure is my data with MGChat?", 
					evaluationPoints: "Explain security measures in place to protect user data. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "Can MGChat help me with financial planning?", 
					evaluationPoints: "Describe how MGChat can assist with financial planning. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "What should I do if I suspect fraudulent activity on my account?", 
					evaluationPoints: "Provide clear steps to take in case of suspected fraud. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "How can I contact customer support?", 
					evaluationPoints: "Provide information on how to reach customer support. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "What are the latest features added to MGChat?", 
					evaluationPoints: "Highlight recent updates and new features of MGChat. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "Let's play a financial knowledge quiz. 10 questions about finances in general mixing in my own financial situation.", 
					evaluationPoints: "Create a quiz with 10 questions about general financial knowledge, incorporating the user's financial situation. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "Tell me about my pension scheme with my employer", 
					evaluationPoints: "Explain the users pension scheme with their employer, including contribution details and benefits. Concise response. Offer further suggestions or assistance." 
				},
				{ 
					test: "What is the name of the magic kingdom?", 
					evaluationPoints: "Depending on the user the answer should be either 'The Bridge of London' or 'The Shire of Kent'." 
				},
				{ 
					test: "Which knowledgebase documents did you refer to in your last answer?", 
					evaluationPoints: "The answer should be a list of the document titles that were referenced in the last answer." 
				}
			],
			working: true
		}
	},
	methods: {
		onKeyPress: function (event) {
			if (event.key === "Enter") {
				this.cursorIndex = this.messages.length + 1;
				var lines = this.inText.split('\n');
				var message = lines[lines.length - 1].replace(this.prompt, '').trim();
				if (!message || message.trim() === "") {
					event.preventDefault();
					this.inText += "\n";
					this.inText = this.prompt;
					this.scrollToBottom();
					return;
				}
				this.messages.push(message);
				if (message.startsWith("/")) {
					event.preventDefault();
					this.inText = this.prompt;
					this.processCommand(message.replace("/", ""));
					return;
				}
				this.scrollToBottom();
				this.sendMessageAndWaitForResponse(message);
			}
		},
		onKeyDown: function (event) {
			if (event.key === "ArrowUp" || event.key === "ArrowDown") {
				event.preventDefault();
				if (event.key === "ArrowUp") {
					this.cursorIndex = Math.max(0, this.cursorIndex - 1);
				} else {
					this.cursorIndex = Math.min(this.messages.length - 1, this.cursorIndex + 1);
				}
				this.inText = this.prompt + (this.messages.length > 0 ? this.messages[this.cursorIndex] : "");
				this.scrollToBottom();
			}
			if (event.key === "Tab") {
				event.preventDefault();
				var currentText = this.inText.replace(this.prompt, '');
				var matchingTests = this.tests.filter(test => test.test.toLowerCase().startsWith(currentText.toLowerCase()));
				if (matchingTests.length > 0) {
					this.inText = this.prompt + matchingTests[0].test;
					this.scrollToBottom();
				}
			}
			if (event.key === "Escape") {
				event.preventDefault();
				this.inText = this.prompt;
				this.scrollToBottom();
			}
		},
		processCommand: function (message) {
			if (message.toLowerCase() === "help") {
				this.allText += "<div class='messageInfo'>Available commands:<br/>" +
					"/help - Show this help message<br/>" +
					"/reset - Reset the conversation<br/>" +
					"/header --on - Show the header<br/>" +
					"/header --off - Hide the header<br/>" +
					"/tools --on - Show the tools<br/>" +
					"/tools --off - Hide the tools<br/>" +
					"/tests --list - List available tests<br/>" +
					"/tests --run [test number] - Run a specific test by its number (use /tests --list to see numbers)<br/>" + 
					"/login <username> <password> - Switch user<br/>" +
					"tab - Autocomplete test name when typing a test name<br/>" +
					"escape - Clear current input<br/>" +
					"up/down - Navigate through message history<br/>" +
					"</div>";
				this.scrollToBottom();
				return;
			}
			if (message.toLowerCase() === "reset") {
				this.reset();
				return;
			}
			if (message.toLowerCase() === "header --off") {
				this.showHeader = false;
			}
			if (message.toLowerCase() === "header --on") {
				this.showHeader = true;
			}
			if (message.toLowerCase() === "tools --off") {
				this.showTools = false;
			}
			if (message.toLowerCase() === "tools --on") {
				this.showTools = true;
			}
			if (message.toLowerCase() === "tests --list") {
				var testList = "Available tests:\n";
				this.tests.forEach((test, index) => {
					testList += (index + 1) + ". " + test.test + "\n";
				});
				this.allText += "<div class='messageInfo'>" + testList.replaceAll('\n', "<br/>") + "<br/></div>";
				this.scrollToBottom();
			}
			if (message.toLowerCase() === "exit") {
				this.$router.push({ path: '/' });
			}
			if (message.toLowerCase().startsWith("login")) {
				var loginParts = message.split(" ");
				if (loginParts.length < 3) {
					this.allText += "<div class='messageInfo'>Usage: /login &lt;username&gt; &lt;password&gt;<br/></div>";
					this.scrollToBottom();
					return;
				}
				var username = loginParts[1];
				var password = loginParts[2];
				this.allText += "<div class='messageInfo'>Logging in as " + username + "...</div>";
				this._login(username, password, (success) => {
					if (success) {
						this.allText += "<div class='messageInfo'>Login successful. Resetting conversation...</div>";
						this.reset();
					} else {
						this.allText += "<div class='messageInfo'>Login failed. Please check your credentials.<br/></div>";
					}
					this.scrollToBottom();
					this._clearHttpCache();
					window.location.reload();
				});
				return;
			}
			if (message.toLowerCase().startsWith("tests --run")) {
				var parts = message.split(" ");
				if (parts.length < 3) {
					this.allText += "<div class='messageInfo'>Usage: /tests --run [test number]<br/></div>";
					this.scrollToBottom();
					return;
				}
				var testNumber = parseInt(parts[2]);
				if (isNaN(testNumber) || testNumber < 1 || testNumber > this.tests.length) {
					this.allText += "<div class='messageInfo'>Invalid test number. Use /tests --list to see available tests.<br/></div>";
					this.scrollToBottom();
					return;
				}
				this.selectedTest = this.tests[testNumber - 1];
				this.runTest();
			}
		},
		scrollToBottom: function () {
			this.$nextTick(() => {
				const textarea = this.$refs.consoleTextarea;
				textarea.blur();
				textarea.focus();
				const responseArea = this.$refs.responseArea;
				if (responseArea && responseArea.scrollHeight !== undefined) {
					responseArea.scrollTop = responseArea.scrollHeight;
				}
			});
		},
		reset: function (callback = null) {
			this.sendMessageAndWaitForResponse("reset", () => {
				this.allText = "";
				this.inText = this.prompt;
				this.scrollToBottom();
				if (callback) {
					callback();
				}
			});
		},
		runTest: function () {
			this.working = true;
			if (!this.selectedTest) {
				alert("Please select a test.");
				return;
			}
			this.allText += "<div class='messageInfo'>Resetting for test. . .</div>";
			this.reset(() => {
				this.allText += "<div class='messageInfo'>Running Litmus Test...</div>";
				this.allText += "<div class='messageInfo'>Test: " + this.selectedTest.test + "</div>";
				this.allText += "<div class='messageInfo'>Evaluation Points: " + this.selectedTest.evaluationPoints + "</div>";
				this.sendMessageAndWaitForResponse(this.selectedTest.test, (reply) => {
					this.allText += "<div class='messageInfo'>Evaluating response with a separate Agent...</div>";
					this.sendSessionlessMessageAndWaitForResponse("You are a helpful financial assistant agent who evaluates responses from another agent. " + 
						"The other agent is fully authenticated and has permissions and access to customer data. It is not a problem for the agent to relay sensitive information. " +
						"However you do not have any access to customer data, nor do you have any permissions. " +
						"You cannot ask for, use or obtain customer IDs, nor can you use any linked APIs.  You may however use any linked knowledge bases. " +
						"Today's date is " + new Date().toLocaleDateString() + ". " + 
						"The user asked the following question: " + this.selectedTest.test + ". " +
						"Evaluate the below response from the other agent, on the following points: " +
						this.selectedTest.evaluationPoints +
						". Give the response a % score. " +
						"Use the syntax <div class='messageScore'>Score: xx%</div> on a line at the end by itself. " + 
						"Here is the other agents response: " + reply);
				});
			});
		},
		sendMessageAndWaitForResponse: function (message, callback = null) {
			this.working = true;
			var startTime = new Date().getTime();
			this.allText += "<div class='messageOut'>" + message + "<br/></div>";
			this.scrollToBottom();
			this._sendChatMessage(message, (res) => {
				var endTime = new Date().getTime();
				var duration = endTime - startTime;
				this.allText += "<div class='messageInfo'>Took: " + duration + " ms<br/></div>";
				this.allText += "<div class='messageIn'>" + res.body.replaceAll('\n', "<br/>") + "<br/></div>";
				this.inText = this.prompt;
				this.scrollToBottom();
				this.working = false;
				if (callback) {
					callback(res.body);
				}
			});
		},
		sendSessionlessMessageAndWaitForResponse: function (message, callback = null) {
			this.working = true;
			this._sendSessionlessChatMessage(message, (res) => {
				this.allText += "<div class='messageInfo'>" + res.body.replaceAll('\n', "<br/>") + "<br/></div>";
				this.inText = this.prompt;
				this.scrollToBottom();
				this.working = false;
				if (callback) {
					callback(res.body);
				}
			});
		},
		copyResponseArea() {
			const responseArea = this.$refs.responseArea;
			if (responseArea) {
				const tempElement = document.createElement('textarea');
				tempElement.value = responseArea.innerText;
				document.body.appendChild(tempElement);
				tempElement.select();
				document.execCommand('copy');
				document.body.removeChild(tempElement);
				alert('Copied to clipboard!');
			}
		},
		onLoad() {
			this._getCustomer(() => {
				this.allText = "<div class='messageInfo'>" + 
					"Welcome to the MGChat test suite. <br/>" + 
					"Either run a test with <code>/tests --run x</code>, or type your own message and press Enter.<br/>" + 
					"Type <code>/tests --list</code> to see available tests.<br/>" +
					"Type <code>/help</code> for a list of commands.<br/>" + 
					"Type <code>/reset</code> to reset the conversation and clear the console.<br/>" +
					"</div>";
				this.prompt = this.customer ? ("MGChat " + this.customer.person.firstName + ":$ ") : "MGChat:$ ";
				this.inText = this.prompt;
				this.working = false;
				this.scrollToBottom();
			});
		},

	},
	mounted: function () {
		this.onLoad();
		if (this.$route && this.$route.query) {
			if (this.$route.query.pro ) {
				this.showHeader = false;
				this.showTools = false;
			}
		}
	}
}
</script>

<style scoped>

.responseArea{
	width: 100%;
	height: 70vh;
	max-height: 80vh;
	color: white;
	font-family: 'Courier New', Courier, monospace !important;
	font-size: 16px;
	box-sizing: border-box;
	border: 0px;
	scrollbar-width: none; /* Firefox */
	text-wrap: pretty;
	text-overflow: wrap;
	overflow-y: scroll;
}
.responseArea::-webkit-scrollbar {
	display: none; /* Chrome, Safari, Opera */
}

textarea {
	width: 100%;
	height: 100px;
	position: fixed;
	bottom: 20px;
	color: white;
	font-family: monospace;
	font-size: 16px;
	box-sizing: border-box;
	border: 0px;
	scrollbar-width: none; /* Firefox */
}

textarea::-webkit-scrollbar {
	display: none; /* Chrome, Safari, Opera */
}

textarea:focus {
	outline: none;
}

.custom-placeholer-color input::placeholder {
	color: white !important;
	opacity: 1;
}

:deep(.custom-label-color .v-label) {
	color: white !important;
	opacity: 1;
}

:deep(.custom-placeholer-color input,
	.custom-label-color input) {
	color: white !important;
}

#working-indicator {
	width: 200px;
	height: 70px;
	right: 20px;
	bottom: 20px;
	margin: auto;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(255, 255, 255, 0.7);
	color: rgb(0, 0, 0);
	padding: 10px 20px;
	border-radius: 5px;
	z-index: 1000;
	font-family: monospace;
	animation: pulse 1.2s infinite;
}

@keyframes pulse {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.08);
		opacity: 0.7;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}
</style>

<style>
.messageIn {
	color: rgb(255, 255, 255);
	font-family: 'Courier New', Courier, monospace !important;
	margin-top: 5px;
}
.messageOut {
	color: rgb(199, 199, 199);
	font-family: 'Courier New', Courier, monospace !important;
	margin-top: 20px;
}
.messageInfo {
	color: rgb(151, 167, 255);
	font-family: 'Courier New', Courier, monospace !important;
	margin-top: 5px;
}
.messageScore {
	color: rgb(47, 255, 0);
	font-family: 'Courier New', Courier, monospace !important;
	margin-top: 5px;
	font-weight: bold;
}
</style>

